import React, { Fragment } from "react";
import { Form } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { FieldHeader } from "../../components/FieldHeader";

function CheckboxesWidget({
  id,
  options,
  value,
  formContext,
  schema,
}: any) {
  const { t } = useSchemaTranslation();

  const { enumOptions, inline } = options;
  const { title } = schema;

  const inlineOption = inline ? { inline: true } : { grouped: true };


  const checkedOptions = enumOptions.filter((option: any, index: number) => value.indexOf(option.value) !== -1);

  return (
    <React.Fragment>
      {title && <FieldHeader>{t(title)}</FieldHeader>}
      <Form.Group {...inlineOption}>
        fdfdfjkoko
        {checkedOptions.length ?
          checkedOptions.map((option: any, index: number) => (
            <Form.Field
              id={`${id}_${index}`}
              key={`${id}_${index}`}
              children={t(option.label)}
            />
          )) : formContext.emptyValue || null}
      </Form.Group>
    </React.Fragment>
  );
}

CheckboxesWidget.defaultProps = {
  options: {
    semantic: {
      inverted: false,
    },
  },
};

export default CheckboxesWidget;
